module.exports = __webpack_public_path__ + "assets/fabricaSinAnimacion.d7377b18401020006fc6f24e12c66637.png";


//////////////////
// WEBPACK FOOTER
// ./img/landingPage/fabricaSinAnimacion.png
// module id = 879
// module chunks = 0